import { IViewStatusEmail } from "../../interfaces/order";
import { useEffect, useState } from "react";
import { fetchData } from "../../utils/dataProvider";
import { GET } from "../../utils/constants";
import { insertLocalImagesOnHtml } from "../../utils/email";

const ViewStatusEmail = ({ status, template, footer }: IViewStatusEmail) => {
  const [emailTemplate, setTemplate] = useState("");
  const fetchStatusTemplate = async () => {
    const htmlTemplate = await fetchData({
      method: GET,
      url: `/orders/customization/email-template?status=${status.status}`,
    });
    const parsedTemplate = insertLocalImagesOnHtml({
      html: htmlTemplate,
      banner: template?.banner_url,
      logo: template?.logo_url,
      description: template?.description,
      footer
    });
    setTemplate(parsedTemplate);
  };
  useEffect(() => {
    fetchStatusTemplate();
  }, [footer]);
  return (
    <>
      {emailTemplate && (
        <div dangerouslySetInnerHTML={{ __html: emailTemplate }} />
      )}
    </>
  );
};

export default ViewStatusEmail;
